import Template1 from "../assets/images/Templates/template1.png";
import Template2 from "../assets/images/Templates/template2.png";
import Template3 from "../assets/images/Templates/template3.png";
import Template4 from "../assets/images/Templates/template4.png";

export const TemplateDataPortrait = [
	Template1,
	Template2,
	Template3,
	Template4,
];

export default TemplateDataPortrait;
